<div class="flex-direction-column height-100" [style]="isHml ? 'height: calc(var(--altura-util-pagina) - 116px)' : 'height: calc(var(--altura-util-pagina) - 100px)'">
  <div class="barra-filtros-disparo">
    <app-button-padrao
      iconSrc="icones/filtros"
      iconSrcExtensao=".svg"
      width="30px"
      height="35px"
      backgroundColor="transparent"
      widthIcon="22px"
      heightIcon="22px"
      matTooltip="Filtrar"
      (buttonClick)="abrirFiltro()">
    </app-button-padrao>

    <app-button-padrao
      iconSrc="icones/limpar"
      iconSrcExtensao=".svg"
      width="30px"
      height="35px"
      backgroundColor="transparent"
      widthIcon="22px"
      heightIcon="22px"
      matTooltip="Limpar filtros"
      (buttonClick)="limparFiltros()">
    </app-button-padrao>

    <app-form-field
      placeholder="Pesquisar por título"
      iconPrefix="search"
      iconColor="var(--primary)"
      backgroundColor="transparent"
      classe="pesquisar"
      widthFormField="325px"
      heightFormField="35px"
      borderColor="var(--primary)"
      [formControl]="pesquisaControl">
    </app-form-field>
  </div>
  @if (disparoAutomaticoList.length > 0 || disparosCarregado) {
    @if (ehMobile) {
      <div class="flex-direction-column gap-10">
        @for (disparo of disparoAutomaticoList; track disparo.id) {
          @let isActiveStatus = disparo.status === 'Enviado' || disparo.status === 'Processando';
          @let statusExibidoMobile = statusParaExibicao(disparo);

          <div class="area-card" role="button" tabindex="0" (click)="executarAcaoPrincipal(disparo)" (keydown.enter)="executarAcaoPrincipal(disparo)">
            <div class="header-card">
              <div class="area-titulo">
                <img src="./assets/icones/visualizar.svg" alt="Visualizar" />
                <span>{{ disparo.tituloDisparo }}</span>
              </div>

              <span [class]="'card-status ellipse ' + classeStatusDisparo(statusExibidoMobile)">{{ statusExibidoMobile }}</span>
            </div>

            <div class="body-card">
              <div class="body-item">
                <span class="titulo">Data Envio</span>
                <span class="item">{{ (disparo.dataEnvio | date:'dd/MM/yyyy - HH:mm') ?? '--' }}</span>
              </div>

              <div class="body-item">
                <span class="titulo">Contatos</span>
                <span class="item flex justify-center">{{ disparo.quantidadeContatos ?? '0' }}</span>
              </div>

              <div class="body-item">
                <span class="titulo">Válidos</span>

                <div class="flex center-center gap-5" style="border-radius: 6px" [ngClass]="disparo.listaContatos?.length === disparo.quantidadeContatosValidos ? 'card-positivo' : 'card-inativo'">
                  <span>{{ disparo.quantidadeContatosValidos }}</span>
                  @if (disparo.listaContatos?.length === disparo.quantidadeContatosValidos) {
                    <img src="assets/icones/ok-verde.svg" alt="Válido">
                  }
                  @else {
                    <img src="assets/icones/down-graphic-vermelho.svg" alt="Inválido">
                  }
                </div>
              </div>

              <div class="body-item">
                <span class="titulo">Enviadas</span>

                @let enviadosAtivoMobile = enviadosAtivo(disparo);
                <div class="flex center-center gap-5" style="border-radius: 6px" [ngClass]="enviadosAtivoMobile ? (disparo.quantidadeContatosValidos === disparo.infos?.numEnviados ? 'card-positivo' : 'card-inativo') : 'nao-enviado-meta'">
                  <span>{{ enviadosAtivoMobile ? (disparo.infos?.numEnviados ?? '0') : '' }}</span>
                  @if (enviadosAtivoMobile) {
                    @if (disparo.quantidadeContatosValidos === disparo.infos?.numEnviados) {
                      <img src="assets/icones/ok-verde.svg" alt="Enviado">
                    }
                    @else {
                      <img src="assets/icones/down-graphic-vermelho.svg" alt="Não enviado">
                    }
                  }
                  @else{
                    <img
                      [src]="ehEmailOuSms(disparo.tipoDisparo) ? iconeTipoEnvio(disparo.tipoDisparo!) : 'assets/icones/icone-meta-azul.svg'"
                      [alt]="disparo.tipoDisparo ?? 'Meta'">
                  }
                </div>
              </div>

              <div class="body-item">
                <span class="titulo">Recebidos</span>

                <div class="flex center-center gap-5" style="border-radius: 6px" [ngClass]="isActiveStatus ? (disparo.infos && disparo.infos.numLidos && disparo.infos.numRecebidos && disparo.infos.numRecebidos === disparo.infos.numLidos ? 'card-positivo' : 'card-inativo') : 'nao-enviado-meta'">
                  <span>{{ isActiveStatus ? (disparo.infos?.numRecebidos ?? '0') : '' }}</span>
                  @if (isActiveStatus) {
                    @if (disparo.infos && disparo.infos.numLidos && disparo.infos.numRecebidos && disparo.infos.numRecebidos === disparo.infos.numLidos) {
                      <img src="assets/icones/ok-verde.svg" alt="Recebido">
                    }
                    @else {
                      <img src="assets/icones/down-graphic-vermelho.svg" alt="Não recebido">
                    }
                  }
                  @else{
                    <img src="assets/icones/icone-meta-azul.svg" alt="Meta">
                  }
                </div>
              </div>

              <div class="body-item">
                <span class="titulo">Lidos</span>

                <div class="flex center-center gap-5" style="border-radius: 6px" [ngClass]="isActiveStatus ? (disparo.infos && disparo.infos.numLidos && disparo.infos.numRecebidos && disparo.infos.numRecebidos === disparo.infos.numLidos ? 'card-positivo' : 'card-inativo') : 'nao-enviado-meta'">
                  <span>{{ isActiveStatus ? (disparo.infos?.numLidos ?? '0') : '' }}</span>
                  @if (isActiveStatus) {
                    @if (disparo.infos && disparo.infos.numLidos && disparo.infos.numRecebidos && disparo.infos.numRecebidos === disparo.infos.numLidos) {
                      <img src="assets/icones/ok-verde.svg" alt="Lido">
                    }
                    @else {
                      <img src="assets/icones/down-graphic-vermelho.svg" alt="Não lido">
                    }
                  }
                  @else{
                    <img src="assets/icones/icone-meta-azul.svg" alt="Meta">
                  }
                </div>
              </div>

              <div class="body-item">
                <span class="titulo">% Alcance</span>
                <div class="flex center-center gap-5" style="border-radius: 6px" [ngClass]="isActiveStatus ? {'card-inativo': !disparo?.infos?.porcentConversao || disparo?.infos?.porcentConversao! < 50,
                            'card-positivo': disparo?.infos?.porcentConversao! > 50,
                            'card-neutro': disparo?.infos?.porcentConversao! === 50 } : 'nao-enviado-meta'">
                  <span>{{ isActiveStatus ? (disparo?.infos?.porcentConversao ?? 0) + '%' : '' }}</span>
                  @if (isActiveStatus) {
                    @if (disparo?.infos?.porcentConversao! > 50) {
                      <img src="assets/icones/rosto-feliz-verde.svg" alt="Bom alcance">
                    }
                    @else if (disparo?.infos?.porcentConversao! === 50) {
                      <img src="assets/icones/rosto-triste-vermelho.svg" alt="Alcance neutro">
                    }
                    @else {
                      <img src="assets/icones/rosto-triste-vermelho.svg" alt="Baixo alcance">
                    }
                  }
                  @else{
                    <img src="assets/icones/icone-meta-azul.svg" alt="Meta">
                  }
                </div>
              </div>

              <div class="body-item">
                <span class="titulo">Interação</span>

                <div class="flex center-center gap-5" style="border-radius: 6px" [ngClass]="isActiveStatus ? (disparo.infos && disparo.infos.numRespondidos && disparo.infos.numLidos === disparo.infos.numRespondidos ? 'card-positivo' : 'card-inativo') : 'nao-enviado-meta'">
                  <span>{{ isActiveStatus ? (disparo.infos?.numRespondidos ?? '0') : '' }}</span>
                  @if (isActiveStatus) {
                    @if (disparo.infos && disparo.infos.numRespondidos && disparo.infos.numLidos === disparo.infos.numRespondidos) {
                      <img src="assets/icones/ok-verde.svg" alt="Interagiu">
                    }
                    @else {
                      <img src="assets/icones/down-graphic-vermelho.svg" alt="Não interagiu">
                    }
                  }
                  @else{
                    <img src="assets/icones/icone-meta-azul.svg" alt="Meta">
                  }
                </div>
              </div>

              <div class="body-item">
                <span class="titulo">% Interação</span>

                <div class="flex center-center gap-5" style="border-radius: 6px" [ngClass]="isActiveStatus ? { 'card-inativo': !disparo?.infos?.porcentRespondidos || disparo?.infos?.porcentRespondidos! < 50,
                            'card-positivo': disparo?.infos?.porcentRespondidos! > 50,
                            'card-neutro': disparo?.infos?.porcentRespondidos! === 50 } : 'nao-enviado-meta'">
                  <span>{{ isActiveStatus ? (disparo?.infos?.porcentRespondidos ?? 0) + '%' : '' }}</span>
                  @if (isActiveStatus) {
                    @if (disparo?.infos?.porcentRespondidos! > 50) {
                      <img src="assets/icones/rosto-feliz-verde.svg" alt="Boa interação">
                    }
                    @else if (disparo?.infos?.porcentRespondidos! === 50) {
                      <img src="assets/icones/rosto-neutro-amarelo.svg" alt="Interação neutra">
                    }
                    @else {
                      <img src="assets/icones/rosto-triste-vermelho.svg" alt="Baixa interação">
                    }
                  }
                  @else{
                    <img src="assets/icones/icone-meta-azul.svg" alt="Meta">
                  }
                </div>
              </div>

              <div class="body-item width-25">
                <span class="titulo">% Resp. Pesquisa</span>

                <div class="flex center-center gap-5" style="border-radius: 6px" [ngClass]="{ 'card-inativo': !disparo?.infos?.porcentPesquisaRespondida || disparo?.infos?.porcentPesquisaRespondida! < 50,
                    'card-positivo': disparo?.infos?.porcentPesquisaRespondida! > 50,
                    'card-neutro': disparo?.infos?.porcentPesquisaRespondida! === 50 }">
                  <span>{{ disparo?.infos?.porcentPesquisaRespondida ?? 0 }}%</span>
                  @if (disparo?.infos?.porcentPesquisaRespondida! > 50) {
                    <img src="assets/icones/rosto-feliz-verde.svg" alt="Boa resposta">
                  }
                  @else if (disparo?.infos?.porcentPesquisaRespondida! === 50) {
                    <img src="assets/icones/rosto-neutro-amarelo.svg" alt="Resposta neutra">
                  }
                  @else {
                    <img src="assets/icones/rosto-triste-vermelho.svg" alt="Baixa resposta">
                  }
                </div>
              </div>

              <div class="body-item width-25">
                <span class="titulo">Template</span>
                <span class="item">{{ disparo.template?.name ?? '--' }}</span>
              </div>

              <div class="body-item">
                <span class="titulo">Fluxo</span>
                <span class="item ellipse">{{ disparo.fluxo?.nome ?? '--' }}</span>
              </div>

              <div class="body-item width-50" style="max-width: 65px !important;">
                <span class="titulo">User Envio</span>
                @if (disparo.usuarioEnvio) {
                  @if (disparo.usuarioEnvio.extensaoImg && disparo.usuarioEnvio.uuid) {
                    <img class="circulo" [src]="gerarUrl(disparo.usuarioEnvio.uuid, disparo.usuarioEnvio.extensaoImg, 'usuario-img')" class="modal-lateral-imagem" style="width: 25px; height: 25px; cursor: unset;" [alt]="disparo.usuarioEnvio.nome ?? 'Usuário'" />
                  } @else {
                    <img src="./assets/icones/no-img-default.png" style="width: 25px; height: 25px" [alt]="disparo.usuarioEnvio.nome ?? 'Usuário'" />
                  }
                } @else {
                  <span class="item">--</span>
                }
              </div>
            </div>
          </div>
        }
      </div>
    } @else {
      @if (disparosCarregado) {
        <app-tabela-skeleton [qntdLinhas]="8"></app-tabela-skeleton>
      } @else {
        <mat-table [dataSource]="disparoAutomaticoTable" class="overflow table-disparos" [class.table-programacoes]="statusGroup === 'PROGRAMACOES'">
          <ng-container matColumnDef="acoes">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let elemento">
              <button mat-icon-button
                      class="btn-more-options"
                      [matMenuTriggerFor]="opcoesMenu"
                      (click)="$event.stopPropagation()">
                <img src="./assets/icones/more-options.svg" style="width:18px; height:18px;" alt="Mais opções" />
              </button>
              <mat-menu #opcoesMenu="matMenu" class="menu-opcoes-disparo">
                @if (statusGroup === 'PROGRAMACOES') {
                  <button mat-menu-item (click)="abrirEdicao(elemento)" [disabled]="estaBuscandoBase(elemento)">
                    Editar
                  </button>
                  <button mat-menu-item (click)="cancelarItemProgramacao(elemento)" [disabled]="elemento.status === 'Cancelado' || estaBuscandoBase(elemento)">
                    Cancelar
                  </button>
                  <button mat-menu-item (click)="abrirLogs(elemento)">
                    Ver logs
                  </button>
                  @if (elemento.ehProgramacaoRecorrente) {
                    <button mat-menu-item (click)="verHistoricoRecorrencia(elemento)">
                      Ver histórico de recorrência
                    </button>
                  }
                } @else if (elemento.ehProgramacaoRecorrente) {
                  <button mat-menu-item (click)="verHistoricoRecorrencia(elemento)">
                    Ver histórico de recorrência
                  </button>
                } @else if (estaBuscandoBase(elemento)) {
                  <button mat-menu-item disabled>
                    Buscando base…
                  </button>
                  <button mat-menu-item (click)="abrirLogs(elemento)">
                    Ver logs
                  </button>
                } @else if (elemento.status === 'Enviado' || elemento.status === 'Cancelado') {
                  <button mat-menu-item (click)="abrirEdicao(elemento)">
                    Visualização
                  </button>
                  <button mat-menu-item (click)="exportarEmPdf(elemento.id)">
                    Exportar em pdf
                  </button>
                } @else {
                  <button mat-menu-item (click)="abrirEdicao(elemento)">
                    Edição
                  </button>
                  <button mat-menu-item (click)="cancelarEnvios(elemento)">
                    Cancelar Envios
                  </button>
                }
                <button mat-menu-item (click)="abrirReplica(elemento)">
                  Replicar
                </button>
              </mat-menu>

            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
            <mat-cell *matCellDef="let elemento"> {{ elemento.id }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
            <mat-cell *matCellDef="let elemento" [matTooltip]="elemento.status">
              @let statusExibido = statusParaExibicao(elemento);
              <span
                class="card-status ellipse"
                [ngClass]="classeStatusDisparo(statusExibido)">
                @if(statusExibido !== 'Processando'){
                  {{ statusExibido }}
                }@else {
                  {{ statusExibido + ' (' + (elemento.infos?.porcProcessados ?? 0) + '%)' }}
                }
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="titulo">
            <mat-header-cell *matHeaderCellDef> Título Disparo </mat-header-cell>
            <mat-cell *matCellDef="let elemento">
              <span class="ellipse" [matTooltip]="elemento.tituloDisparo">{{ elemento.tituloDisparo ?? '--' }} </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="numero">
            <mat-header-cell *matHeaderCellDef> Envio </mat-header-cell>
            <mat-cell *matCellDef="let elemento" [matTooltip]="obterEnvio(elemento)">
              <span class="ellipse" style="max-width: unset">{{ obterEnvio(elemento) }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="dataEnvio">
            <mat-header-cell *matHeaderCellDef> {{ statusGroup === 'PROGRAMACOES' ? 'Dt/Hr Envio' : 'Data Envio' }} </mat-header-cell>
            <mat-cell *matCellDef="let elemento">
              @if(elemento.dataEnvio) {
                <span class="ellipse" [matTooltip]="(elemento.dataEnvio | date:'dd/MM/yyyy - HH:mm') ?? '--'">{{ (elemento.dataEnvio | date:'dd/MM/yyyy - HH:mm') ?? '--' }} </span>
              }
              @else if(elemento.dataAgendamento && elemento.horaAgendamento){
                <div class="center-center gap-5" [matTooltip]="(elemento.dataAgendamento | date:'dd/MM/yyyy') + ' - ' + (elemento.horaAgendamento ?? '--')">
                  <img src="assets/icones/calendar-clock 1.svg" alt="Agendado">
                  <span class="ellipse" style="color: #FF5C00">
                    {{ (elemento.dataAgendamento | date:'dd/MM/yyyy') }} - {{ elemento.horaAgendamento }}
                  </span>
                </div>
              }
              @else {
                <span class="ellipse">--</span>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="tipoEnvio">
            <mat-header-cell *matHeaderCellDef> Tipo Envio </mat-header-cell>
            <mat-cell *matCellDef="let elemento" [matTooltip]="elemento.tipoDisparo ?? '--'">
              @if (iconeTipoEnvio(elemento.tipoDisparo)) {
                <img class="icone-tipo-envio" [src]="iconeTipoEnvio(elemento.tipoDisparo)" [alt]="elemento.tipoDisparo">
              } @else {
                <span>--</span>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="quantidadeEnvios">
            <mat-header-cell *matHeaderCellDef> Qtd Envios </mat-header-cell>
            <mat-cell *matCellDef="let elemento">{{ elemento.quantidadeEnvios ?? '-' }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="erros">
            <mat-header-cell *matHeaderCellDef> Erros </mat-header-cell>
            <mat-cell *matCellDef="let elemento">{{ elemento.quantidadeErros ?? '-' }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="investimentoAcumulado">
            <mat-header-cell *matHeaderCellDef> Invest. total </mat-header-cell>
            <mat-cell *matCellDef="let elemento">
              {{ elemento.investimentoAcumulado === null || elemento.investimentoAcumulado === undefined ? '-' : formatUSD(elemento.investimentoAcumulado) }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="template">
            <mat-header-cell *matHeaderCellDef> Template </mat-header-cell>
            <mat-cell *matCellDef="let elemento">
              <span class="ellipse" [matTooltip]="elemento.template?.name ?? '--'">{{ elemento.template?.name ?? '--' }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="etapa">
            <mat-header-cell *matHeaderCellDef> Etapa </mat-header-cell>
            <mat-cell *matCellDef="let elemento">
              <span class="ellipse" [matTooltip]="elemento.etapa?.titulo ?? '--'">{{ elemento.etapa?.titulo ?? '--' }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="setor">
            <mat-header-cell *matHeaderCellDef> Setor </mat-header-cell>
            <mat-cell *matCellDef="let elemento">
              <span class="ellipse" [matTooltip]="elemento.setor?.nome ?? '--'">{{ elemento.setor?.nome ?? '--' }} </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="investimento">
            <mat-header-cell *matHeaderCellDef> Invest. </mat-header-cell>
            <mat-cell *matCellDef="let elemento">
              <span class="ellipse" [matTooltip]="elemento.investimento ? formatUSD(elemento.investimento) : 'Disparo sem valor investido'">{{ elemento.investimento ? formatUSD(elemento.investimento) : '-' }} </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="contatos">
            <mat-header-cell *matHeaderCellDef> Contatos </mat-header-cell>
            <mat-cell *matCellDef="let elemento" [matTooltip]="elemento.quantidadeContatos ?? '0'">
            <span class="ellipse">{{ elemento.quantidadeContatos ?? '0' }}</span> </mat-cell>
          </ng-container>

          <ng-container matColumnDef="validos">
            <mat-header-cell *matHeaderCellDef> Válidos </mat-header-cell>
            <mat-cell *matCellDef="let elemento" [matTooltip]="elemento.quantidadeContatosValidos">
              <div class="flex center-center gap-5" [ngClass]="elemento.listaContatos?.length === elemento.quantidadeContatosValidos ? 'card-positivo' : 'card-inativo'">
                <span>{{ elemento.quantidadeContatosValidos }}</span>
                @if (elemento.listaContatos?.length === elemento.quantidadeContatosValidos) {
                  <img src="assets/icones/ok-verde.svg" alt="Válido">
                }
                @else {
                  <img src="assets/icones/down-graphic-vermelho.svg" alt="Inválido">
                }
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="enviados">
            <mat-header-cell *matHeaderCellDef> Enviados </mat-header-cell>
            <mat-cell *matCellDef="let elemento" [matTooltip]="ehEmailOuSms(elemento.tipoDisparo) ? '' : enviadosAtivo(elemento) ? (elemento.infos?.numEnviados ?? '0') : ''">
              @let isActiveStatus = enviadosAtivo(elemento);
              <div class="flex center-center gap-5"
                  [ngClass]="isActiveStatus ? (elemento.quantidadeContatosValidos === elemento.infos?.numEnviados ? 'card-positivo' : 'card-inativo') : ehEmailOuSms(elemento.tipoDisparo) ? 'meta-canal-roxo' : 'nao-enviado-meta'">
                <span>{{ isActiveStatus ? (elemento.infos?.numEnviados ?? '0') : '' }}</span>
                @if (isActiveStatus) {
                  @if (elemento.quantidadeContatosValidos === elemento.infos?.numEnviados) {
                    <img src="assets/icones/ok-verde.svg" alt="Enviado">
                  }
                  @else {
                    <img src="assets/icones/down-graphic-vermelho.svg" alt="Não enviado">
                  }
                }
                @else{
                  <img
                    [src]="ehEmailOuSms(elemento.tipoDisparo) ? iconeTipoEnvio(elemento.tipoDisparo) : 'assets/icones/icone-meta-azul.svg'"
                    [alt]="elemento.tipoDisparo ?? 'Meta'">
                }
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="recebidos">
            <mat-header-cell *matHeaderCellDef> Recebidos </mat-header-cell>
            <mat-cell *matCellDef="let elemento" [matTooltip]="ehEmailOuSms(elemento.tipoDisparo) ? '' : (elemento.status === 'Enviado' || elemento.status === 'Processando') ? (elemento.infos?.numRecebidos ?? '0') : ''">
              @if (ehEmailOuSms(elemento.tipoDisparo)) {
                <div class="flex center-center meta-canal-roxo" [matTooltip]="'Indisponível para ' + elemento.tipoDisparo">
                  <img [src]="iconeTipoEnvio(elemento.tipoDisparo)" [alt]="elemento.tipoDisparo">
                </div>
              } @else {
              @let isActiveStatus = elemento.status === 'Enviado' || elemento.status === 'Processando';
              <div class="flex center-center gap-5"
                  [ngClass]="isActiveStatus ? (elemento.infos && elemento.infos.numRecebidos && elemento.infos?.numEnviados === elemento.infos?.numRecebidos ? 'card-positivo' : 'card-inativo') : 'nao-enviado-meta'">
                <span>{{ isActiveStatus ? (elemento.infos?.numRecebidos ?? '0') : '' }}</span>
                @if (isActiveStatus) {
                  @if (elemento.infos && elemento.infos.numRecebidos && elemento.infos?.numEnviados === elemento.infos?.numRecebidos) {
                    <img src="assets/icones/ok-verde.svg" alt="Recebido">
                  }
                  @else {
                    <img src="assets/icones/down-graphic-vermelho.svg" alt="Não recebido">
                  }
                }
                @else{
                  <img src="assets/icones/icone-meta-azul.svg" alt="Meta">
                }
              </div>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="lidos">
            <mat-header-cell *matHeaderCellDef> Lidos </mat-header-cell>
            <mat-cell *matCellDef="let elemento" [matTooltip]="ehEmailOuSms(elemento.tipoDisparo) ? '' : (elemento.status === 'Enviado' || elemento.status === 'Processando') ? (elemento.infos?.numLidos ?? '0') : ''">
              @if (ehEmailOuSms(elemento.tipoDisparo)) {
                <div class="flex center-center meta-canal-roxo" [matTooltip]="'Indisponível para ' + elemento.tipoDisparo">
                  <img [src]="iconeTipoEnvio(elemento.tipoDisparo)" [alt]="elemento.tipoDisparo">
                </div>
              } @else {
              @let isActiveStatus = elemento.status === 'Enviado' || elemento.status === 'Processando';
              <div class="flex center-center gap-5"
                  [ngClass]="isActiveStatus ? (elemento.infos && elemento.infos.numLidos && elemento.infos?.numRecebidos === elemento.infos?.numLidos ? 'card-positivo' : 'card-inativo') : 'nao-enviado-meta'">
                <span>{{ isActiveStatus ? (elemento.infos?.numLidos ?? '0') : '' }}</span>
                @if (isActiveStatus) {
                  @if (elemento.infos && elemento.infos.numLidos && elemento.infos?.numRecebidos === elemento.infos?.numLidos) {
                    <img src="assets/icones/ok-verde.svg" alt="Lido">
                  }
                  @else {
                    <img src="assets/icones/down-graphic-vermelho.svg" alt="Não lido">
                  }
                }
                @else{
                  <img src="assets/icones/icone-meta-azul.svg" alt="Meta">
                }
              </div>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="porcentagemAlcance">
            <mat-header-cell *matHeaderCellDef> % Alcance </mat-header-cell>
            <mat-cell *matCellDef="let elemento" [matTooltip]="ehEmailOuSms(elemento.tipoDisparo) ? '' : (elemento.status === 'Enviado' || elemento.status === 'Processando') ? (elemento?.infos?.porcentConversao ?? 0) + '%' : ''">
              @if (ehEmailOuSms(elemento.tipoDisparo)) {
                <div class="flex center-center meta-canal-roxo" [matTooltip]="'Indisponível para ' + elemento.tipoDisparo">
                  <img [src]="iconeTipoEnvio(elemento.tipoDisparo)" [alt]="elemento.tipoDisparo">
                </div>
              } @else {
              @let isActiveStatus = elemento.status === 'Enviado' || elemento.status === 'Processando';
              <div class="flex center-center gap-5"
                  [ngClass]="isActiveStatus ? { 'card-positivo': elemento?.infos?.porcentConversao > 50, 'card-neutro': elemento?.infos?.porcentConversao === 50, 'card-inativo': elemento?.infos?.porcentConversao < 50 } : 'nao-enviado-meta'">
                <span>{{ isActiveStatus ? (elemento?.infos?.porcentConversao ?? 0) + '%' : '' }}</span>
                @if (isActiveStatus) {
                  @if (elemento?.infos?.porcentConversao > 50) {
                    <img src="assets/icones/rosto-feliz-verde.svg" alt="Bom alcance">
                  }
                  @else if (elemento?.infos?.porcentConversao === 50) {
                    <img src="assets/icones/rosto-neutro-amarelo.svg" alt="Alcance neutro">
                  }
                  @else {
                    <img src="assets/icones/rosto-triste-vermelho.svg" alt="Baixo alcance">
                  }
                }
                @else{
                  <img src="assets/icones/icone-meta-azul.svg" alt="Meta">
                }
              </div>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="interacao">
            <mat-header-cell *matHeaderCellDef> Interação </mat-header-cell>
            <mat-cell *matCellDef="let elemento" [matTooltip]="ehEmailOuSms(elemento.tipoDisparo) ? '' : (elemento.status === 'Enviado' || elemento.status === 'Processando') ? (elemento.infos?.numRespondidos ?? '0') : ''">
              @if (ehEmailOuSms(elemento.tipoDisparo)) {
                <div class="flex center-center meta-canal-roxo" [matTooltip]="'Indisponível para ' + elemento.tipoDisparo">
                  <img [src]="iconeTipoEnvio(elemento.tipoDisparo)" [alt]="elemento.tipoDisparo">
                </div>
              } @else {
              @let isActiveStatus = elemento.status === 'Enviado' || elemento.status === 'Processando';
              <div class="flex center-center gap-5"
                  [ngClass]="isActiveStatus ? (elemento.infos && elemento.infos.numRespondidos && elemento.infos.numLidos === elemento.infos.numRespondidos ? 'card-positivo' : 'card-inativo') : 'nao-enviado-meta'">
                <span>{{ isActiveStatus ? (elemento.infos?.numRespondidos ?? '0') : '' }}</span>
                @if (isActiveStatus) {
                  @if (elemento.infos && elemento.infos.numRespondidos && elemento.infos.numLidos === elemento.infos.numRespondidos) {
                    <img src="assets/icones/ok-verde.svg" alt="Interagiu">
                  }
                  @else {
                    <img src="assets/icones/down-graphic-vermelho.svg" alt="Não interagiu">
                  }
                }
                @else{
                  <img src="assets/icones/icone-meta-azul.svg" alt="Meta">
                }
              </div>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="porcentagemInteracao">
            <mat-header-cell *matHeaderCellDef> % Interação </mat-header-cell>
            <mat-cell *matCellDef="let elemento" [matTooltip]="ehEmailOuSms(elemento.tipoDisparo) ? '' : (elemento.status === 'Enviado' || elemento.status === 'Processando') ? (elemento?.infos?.porcentRespondidos ?? 0) + '%' : ''">
              @if (ehEmailOuSms(elemento.tipoDisparo)) {
                <div class="flex center-center meta-canal-roxo" [matTooltip]="'Indisponível para ' + elemento.tipoDisparo">
                  <img [src]="iconeTipoEnvio(elemento.tipoDisparo)" [alt]="elemento.tipoDisparo">
                </div>
              } @else {
              @let isActiveStatus = elemento.status === 'Enviado' || elemento.status === 'Processando';
              <div class="flex center-center gap-5"
                  [ngClass]="isActiveStatus ? { 'card-positivo': elemento?.infos?.porcentRespondidos > 50, 'card-neutro': elemento?.infos?.porcentRespondidos === 50, 'card-inativo': elemento?.infos?.porcentRespondidos < 50 } : 'nao-enviado-meta'">
                <span>{{ isActiveStatus ? (elemento?.infos?.porcentRespondidos ?? 0) + '%' : '' }}</span>
                @if (isActiveStatus) {
                  @if (elemento?.infos?.porcentRespondidos > 50) {
                    <img src="assets/icones/rosto-feliz-verde.svg" alt="Boa interação">
                  }
                  @else if (elemento?.infos?.porcentRespondidos === 50) {
                    <img src="assets/icones/rosto-neutro-amarelo.svg" alt="Interação neutra">
                  }
                  @else {
                    <img src="assets/icones/rosto-triste-vermelho.svg" alt="Baixa interação">
                  }
                }
                @else{
                  <img src="assets/icones/icone-meta-azul.svg" alt="Meta">
                }
              </div>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="porcentagemRespostaPesquisa">
            <mat-header-cell *matHeaderCellDef>% Pesq.</mat-header-cell>
            <mat-cell *matCellDef="let elemento">
              @let porcentagem = elemento?.infos?.porcentPesquisaRespondida;
              @if (porcentagem === null || porcentagem === undefined || porcentagem <= 0) {
                <span>-</span>
              }
              @else {
                <div class="flex center-center gap-5" [matTooltip]="porcentagem + '%'" [ngClass]="{ 'card-positivo': porcentagem > 50, 'card-neutro': porcentagem === 50, 'card-inativo': porcentagem < 50 }">
                  <span>{{ porcentagem }}%</span>
                  @if (porcentagem > 50) {
                    <img src="assets/icones/rosto-feliz-verde.svg" alt="Boa resposta">
                  }
                  @else if (porcentagem === 50) {
                    <img src="assets/icones/rosto-neutro-amarelo.svg" alt="Resposta neutra">
                  }
                  @else {
                    <img src="assets/icones/rosto-triste-vermelho.svg" alt="Baixa resposta">
                  }
                </div>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="fluxo">
            <mat-header-cell *matHeaderCellDef> Fluxo </mat-header-cell>
            <mat-cell *matCellDef="let elemento" [matTooltip]="elemento.fluxo?.nome ?? '--'">
              <span class="ellipse">{{ elemento.fluxo?.nome ?? '--' }} </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="usuEnvio">
            <mat-header-cell *matHeaderCellDef> Usu. Envio </mat-header-cell>
            <mat-cell *matCellDef="let elemento">
              @if (elemento.usuarioEnvio && elemento.usuarioEnvio.extensaoImg && elemento.usuarioEnvio.uuid) {
                <img class="circulo" [src]="gerarUrl(elemento.usuarioEnvio.uuid, elemento.usuarioEnvio.extensaoImg, 'usuario-img')" class="modal-lateral-imagem" style="width: 25px; height: 25px; cursor: unset;" [matTooltip]="elemento.usuarioEnvio?.nome ?? '--'" [alt]="elemento.usuarioEnvio?.nome ?? 'Usuário'">
              } @else {
                <img src="./assets/icones/no-img-default.png" style="width: 25px; height: 25px" [matTooltip]="elemento?.usuarioEnvio?.nome ?? '--'" [alt]="elemento.usuarioEnvio?.nome ?? 'Usuário'"/>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="integracao">
            <mat-header-cell *matHeaderCellDef> Integração </mat-header-cell>
            <mat-cell *matCellDef="let elemento">
              <span [style.color]="elemento.possuiIntegracao ? 'var(--verde-padrao)' : 'var(--vermelho-padrao)'">{{ elemento.possuiIntegracao ? 'Sim' : 'Não' }}</span>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;" [class.linha-atualizada]="row.atualizadoAgora"></mat-row>
        </mat-table>
        <app-paginator
          [length]="length"
          [pageSize]="limit"
          [pageIndex]="page"
          [width]="'calc(100% - 16px) !important'"
          (pageChange)="handlePageEvent($event)">
        </app-paginator>
        @if (permitirCriacao) {
          <img src="./assets/botao-add.svg" style="bottom: 7px;" class="botao-add cursor-pointer" alt="Adicionar disparo" role="button" tabindex="0" (click)="abrirCriacaoEmit()" (keydown.enter)="abrirCriacaoEmit()" />
        }
      }
    }
  }
  @if (disparoAutomaticoList.length === 0 && !disparosCarregado) {
    <div class="width-100 height-93 flex center-center">
      <div class="flex-direction-column center-center gap-10">
        <img src="assets/imagem-mulher-nao-eh-bug.png" alt="Nenhum resultado encontrado">
        <span>{{ textoVazio }}</span>
        @if (permitirCriacao) {
          <img src="./assets/botao-add.svg" class="cursor-pointer" alt="Adicionar disparo" role="button" tabindex="0" (click)="abrirCriacaoEmit()" (keydown.enter)="abrirCriacaoEmit()" />
        }
      </div>
    </div>
  }
</div>
